import moment from "moment";
import CardClass from "../../CardClass";
import MUIButton from "@mui/material/Button";
import MUIGrid from "@mui/material/Grid2";
import MUITextField from "@mui/material/TextField";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";

export default class CardPatientSearchFilters extends CardClass {
  /**
   * Render the content.
   */
  renderContent() {
    const handlePhoneNumberChange = (event) => {
      const { value } = event.target;

      const formatted = value
        .replace(/\D/g, "")
        .replace(/^(\d{0,3})(\d{0,3})(\d{0,4}).*/, (_, p1, p2, p3) => {
          if (!p2) return p1;
          if (!p3) return `(${p1}) ${p2}`;
          return `(${p1}) ${p2}-${p3}`;
        });

      this.props.onChange({ phone: formatted });
    };

    return (
      <MUIGrid container spacing={2}>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            autoFocus={true}
            size="small"
            label="First Name"
            variant="standard"
            helperText="Starts with or exact match"
            fullWidth={true}
            onBlur={(e) =>
              this.props.onChange({ firstname: e.target.value.trim() })
            }
            onChange={(e) => this.props.onChange({ firstname: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                this.props.onConfirm();
              }
            }}
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            size="small"
            label="Last Name"
            variant="standard"
            helperText="Starts with or exact match"
            fullWidth={true}
            onBlur={(e) =>
              this.props.onChange({ lastname: e.target.value.trim() })
            }
            onChange={(e) => this.props.onChange({ lastname: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                this.props.onConfirm();
              }
            }}
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUIDatePicker
            label="DOB"
            slotProps={{
              field: {
                clearable: true,
              },
              textField: {
                fullWidth: true,
                size: "small",
                variant: "standard",
                InputLabelProps: {
                  shrink: true,
                },
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    this.props.onConfirm();
                  }
                },
              },
            }}
            onChange={(value) => {
              const formattedDate =
                value && moment(value).isValid()
                  ? moment(value).format("M/D/YYYY")
                  : null;
              this.props.onChange({ birthDate: formattedDate });
            }}
            views={["year", "month", "day"]}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={this.props.params ? this.props.params.phone : ""}
            size="small"
            label="Phone Number"
            variant="standard"
            fullWidth={true}
            onChange={handlePhoneNumberChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                this.props.onConfirm();
              }
            }}
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            size="small"
            label="Policy # / MBI"
            variant="standard"
            helperText="Partial or exact match"
            fullWidth={true}
            onBlur={(e) =>
              this.props.onChange({
                insurancePolicyNumberOrMBI: e.target.value.trim(),
              })
            }
            onChange={(e) =>
              this.props.onChange({
                insurancePolicyNumberOrMBI: e.target.value,
              })
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                this.props.onConfirm();
              }
            }}
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filters";
  }

  /**
   * Renders add member button.
   */
  getActions() {
    return [
      <MUIButton
        loading={this.props.loading}
        component="label"
        variant="contained"
        onClick={this.props.onConfirm}
      >
        Search
      </MUIButton>,
    ];
  }
}
